import config from '@/config';
import { requests } from '.';
export var EmailRecordENUM;
(function (EmailRecordENUM) {
    EmailRecordENUM["CNAME"] = "CNAME";
    EmailRecordENUM["TXT"] = "TXT";
    EmailRecordENUM["MX"] = "MX";
})(EmailRecordENUM || (EmailRecordENUM = {}));
export const EmailService = {
    getEmailISVDomainRecords: (params) => requests(config.EMAIL_ISV_SERVICE_URL).get(`/feature/domain/${params.domain}`, {
        params: {
            locationId: params.locationId,
            companyId: params.companyId,
        },
    }),
};
